import React, { useCallback, useContext, useEffect, useState } from "react";
import AuthContext from "../../../hooks/authContext";
import { formDateCustom } from "../../../services/helpers";
import CommunicationsCard from "./CommunicationsCard";
import styles from "../dashboard.module.scss";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { getSupportTickets } from "../../../services/apiservices/support";

function SupportTickets() {
  const auth = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

  const getSupports = useCallback(async () => {
    try {
      const [ticketRes] = await Promise.all([getSupportTickets(companyId)]);
      if (!ticketRes?.data?.length) return;
      let totalNotFoundCount = 0;
      const newData = ticketRes?.data?.map((item) => {
        if (Array.isArray(item?.readUser)) {
            const isRead = item?.readUser?.includes(auth?.userProfile?.id);
            if (!isRead) {
                totalNotFoundCount += 1;
            }
          }
        return {
          user: `Ticket #${item?.ticketNumber}`,
          time: formDateCustom(item?.createdAt),
          preview: item?.subject ?? "",
          id: item?.id
        };
      });
      setCount(totalNotFoundCount);
      const details = sortingFunction(newData.slice(0, 5));
      setData(details);
    } catch (err) {
      console.error("Error loading team messages:", err);
    }
  }, [auth?.userProfile, companyId]);

  useEffect(() => {
    getSupports();
  }, [getSupports]);

  const sortingFunction = (data) => {
    return data.sort((a, b) => {
      if (a.updatedAt < b.updatedAt) return -1;
      if (a.updatedAt > b.updatedAt) return 1;
      return 0;
    });
  };

  return (
    <CommunicationsCard
      icon={<ErrorOutlineIcon className={styles.iconBlue} />}
      updates={data}
      title="My Tickets"
      count={count}
      to="/manageSupportDetails"
      viewAll="/help/manageSupport"
    />
  );
}

export default SupportTickets;
